import { render, staticRenderFns } from "./meta-info.vue?vue&type=template&id=2dba6a50&scoped=true&"
import script from "./meta-info.vue?vue&type=script&lang=js&"
export * from "./meta-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba6a50",
  null
  
)

export default component.exports